export default {
  getTimeZone() { // GMT+08:00
    var offsetMinutes = new Date().getTimezoneOffset();
    var offsetHours = Math.abs(Math.floor(offsetMinutes / 60)); // 将偏差值转换为小时
    var offsetSign = offsetMinutes < 0 ? "+" : "-"; // 根据时区偏差的正负号确定东西半球
    var offsetMinutes = Math.abs(offsetMinutes % 60); // 获取分钟偏差
  
    return "GMT" + offsetSign + offsetHours.toString().padStart(2, '0') + ":" + offsetMinutes.toString().padStart(2, '0');
  },

  getTimeZoneText() { // Asia/Shanghai
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}